import type { SectionTheme } from "#lib/web-ui/primitives/index.js";

export interface InvestmentType {
	key: string;
	label: string;
	defaultReturn: number;
	color: string;
}

export interface InvestmentCalculatorProps {
	theme?: SectionTheme;
	id?: string;
	class?: string;
	title?: string;
	subtitle?: string;
	defaults?: {
		initialInvestment?: number;
		years?: number;
	};
	investmentTypes?: InvestmentType[];
}

export const defaultInvestmentTypes: InvestmentType[] = [
	{ key: "rentalProperty", label: "Rental Property", defaultReturn: 6.72, color: "#0088FE" },
	{ key: "privateDebt", label: "Private Debt", defaultReturn: 10, color: "#00C49F" },
	{ key: "syndication", label: "Syndication", defaultReturn: 18.3, color: "#FFBB28" },
	{ key: "stockMarket", label: "Stock Market", defaultReturn: 12.4, color: "#FF8042" }
];
